module.exports = __webpack_public_path__ + "img/fastfood.34e68755.jpg";